import { connect } from 'react-redux'
import LegislationBreadcrumbs from 'pages/legislation/LegislationBreadcrumbs'

const mapStateToProps = state => ({
  act: state.legislation.act,
  actIdMap: state.legislation.actIdMap
})

export default connect(mapStateToProps, null)(LegislationBreadcrumbs)
